import defineActionTypes from 'utils/defineActionTypes';

// Define action types
export default defineActionTypes('gdpr', ['SET_IS_ACCEPT_GDPR']);
